import { useTranslation } from "@impero-com/common/utils/i18n";
import { useOutletContext } from "react-router-dom";

import { AssignmentTable } from "org/user/components/AssignmentTable";
import { useTestingControlsForUserQuery } from "org/user/queries/useTestingControlsForUserQuery";
import { OutletContext } from "org/user/UserViewPage";
import { getFilterModeConfig } from "utils/table/getFilterModeConfig";

import {
    TestingControlRow,
    useUserTestingControlListTable,
} from "./useUserTestingControlListTable";

export function UserTestingControlsList() {
    const { user } = useOutletContext<OutletContext>();
    const userId = user.id;
    const { data: testingControls } = useTestingControlsForUserQuery(userId);
    const { t } = useTranslation();

    const { table, getFilterComponent, canAddException, tableId } =
        useUserTestingControlListTable(testingControls, userId);

    const modeConfig = getFilterModeConfig(t);

    return (
        <AssignmentTable<TestingControlRow>
            table={table}
            tableId={tableId}
            getFilterComponent={getFilterComponent}
            canAddException={canAddException}
            modeConfig={modeConfig}
        />
    );
}
